(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  class TosHeroCarousel {
    constructor(root) {
      this.root = root;
      this.slides = [...root.querySelectorAll('[data-tos-slide]')];
      this.dots = [...root.querySelectorAll('[data-tos-dot]')];
      this.index = 0;
      this.timer = null;
      this.autoplay = root.dataset.autoplay === 'true';
      this.interval = Number(root.dataset.interval || 5000);

      if (this.slides.length <= 1) return;

      root.querySelector('[data-tos-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      root.querySelector('[data-tos-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(Number(dot.dataset.tosDot)));
      });

      root.addEventListener('mouseenter', () => this.stop());
      root.addEventListener('mouseleave', () => this.start());
      this.start();
    }

    go(next) {
      const total = this.slides.length;
      this.index = ((next % total) + total) % total;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
      this.start();
    }

    start() {
      this.stop();
      if (!this.autoplay || this.slides.length <= 1) return;
      this.timer = setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }
  }

  document.querySelectorAll('[data-tos-hero]').forEach((el) => new TosHeroCarousel(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-bestsellers-coverflow"] && !Shopify.designMode) return;
  try {
    
  class TosCoverflow {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-tos-cf-track]');
      this.viewport = root.querySelector('[data-tos-cf-viewport]');
      this.dotsWrap = root.querySelector('[data-tos-cf-dots]');
      this.sideCount = Number(root.dataset.sideCount || 3);
      this.index = 0;
      this.dragX = 0;
      this.startX = 0;
      this.dragging = false;
      this.slides = [];
      this.#init();
    }

    async #init() {
      const useDynamic = this.root.dataset.dynamic !== 'false';

      if (useDynamic) {
        this.viewport?.classList.add('is-loading');
        try {
          await this.#loadDynamicProducts();
        } catch (err) {
          console.warn('Bestsellers dynamic load failed', err);
        }
        this.viewport?.classList.remove('is-loading');
      }

      this.slides = [...this.root.querySelectorAll('[data-tos-cf-slide]')];
      if (this.slides.length === 0) return;

      if (!useDynamic && this.root.dataset.shuffle !== 'false') {
        this.#shuffleInPlace(this.slides.length);
      }

      this.#buildDots();
      this.#bind();
      this.#render();
    }

    async #loadDynamicProducts() {
      const handle = this.root.dataset.collectionHandle || 'all';
      const showCount = Math.max(1, Number(this.root.dataset.showCount) || 20);
      const productsCount = Math.max(0, Number(this.root.dataset.productsCount) || 0);
      const pageSize = 50;
      const maxPage = Math.max(1, Math.ceil((productsCount || pageSize) / pageSize));
      const pagesToFetch = Math.min(4, maxPage);
      const pages = new Set();

      while (pages.size < pagesToFetch) {
        pages.add(1 + Math.floor(Math.random() * maxPage));
      }

      const rootUrl = this.root.dataset.root || '/';
      const base = rootUrl.endsWith('/') ? rootUrl.slice(0, -1) : rootUrl;
      const results = await Promise.all(
        [...pages].map(async (page) => {
          const url = `${base}/collections/${encodeURIComponent(handle)}/products.json?limit=${pageSize}&page=${page}`;
          const res = await fetch(url);
          if (!res.ok) return [];
          const data = await res.json();
          return data.products || [];
        })
      );

      const byId = new Map();
      results.flat().forEach((product) => {
        if (product?.id) byId.set(product.id, product);
      });

      let pool = [...byId.values()];
      if (pool.length === 0) return;

      pool = this.#shuffleArray(pool).slice(0, showCount);
      if (!this.track) return;

      this.track.innerHTML = '';
      pool.forEach((product, i) => {
        this.track.appendChild(this.#createSlide(product, i, base));
      });
    }

    #createSlide(product, index, base) {
      const slide = document.createElement('div');
      slide.className = 'tos-coverflow__slide resource-list__item';
      slide.dataset.tosCfSlide = '';
      slide.dataset.index = String(index);

      const variant = product.variants?.[0] || {};
      const price = variant.price;
      const compare = variant.compare_at_price;
      const image =
        product.images?.[0]?.src ||
        product.featured_image ||
        '';
      const sizedImage = image ? image.replace(/(\.(jpg|jpeg|png|webp|gif))(\?|$)/i, '_540x675_crop_center$1$3') : '';
      const href = `${base}/products/${product.handle}`;
      const title = product.title || 'Product';
      const safeTitle = this.#escapeHtml(title);
      const hasCompare =
        compare && price && Number(compare) > Number(price);
      const variantId = variant.id;
      const canAdd = variantId != null && variant.available !== false;

      slide.innerHTML = `
        <article class="product-card tos-cf-card">
          <div class="card-gallery tos-cf-card__media">
            ${
              sizedImage
                ? `<img src="${sizedImage}" alt="" loading="lazy" width="540" height="675">`
                : ''
            }
            ${
              canAdd
                ? `<div class="quick-add" data-quick-add-button="add">
                    <button
                      type="button"
                      class="button quick-add__button quick-add__button--add add-to-cart-button"
                      data-tos-cf-atc
                      data-variant-id="${variantId}"
                      data-product-id="${product.id}"
                      aria-label="Add ${safeTitle} to cart"
                    >
                      <span class="add-to-cart-text">
                        <span aria-hidden="true" class="svg-wrapper add-to-cart-icon">
                          <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"/>
                            <path stroke="currentColor" stroke-linecap="round" stroke-width="var(--icon-stroke-width)" d="M14.608 12.563v5m2.5-2.5h-5"/>
                          </svg>
                        </span>
                        <span class="add-to-cart-text__content is-visually-hidden-mobile">
                          <span><span>Add</span></span>
                        </span>
                      </span>
                      <span class="tos-cf-added" aria-hidden="true">
                        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m4.5 10.5 3.5 3.5 7.5-8"/></svg>
                        Added
                      </span>
                    </button>
                  </div>`
                : ''
            }
          </div>
          <div class="tos-cf-card__body">
            <h3 class="tos-cf-card__title">${safeTitle}</h3>
            <div class="tos-cf-card__price-row">
              <p class="tos-cf-card__price">${this.#formatMoney(price)}</p>
              ${
                hasCompare
                  ? `<p class="tos-cf-card__compare">${this.#formatMoney(compare)}</p>`
                  : ''
              }
            </div>
          </div>
          <a class="tos-cf-card__link" href="${href}" aria-label="${safeTitle}" tabindex="-1"></a>
        </article>
      `;

      return slide;
    }

    async #addToCart(button) {
      const variantId = button.dataset.variantId;
      if (!variantId || button.dataset.busy === 'true') return;

      const routes = (window.Theme && window.Theme.routes) || {};
      const addUrl = routes.cart_add_url || '/cart/add.js';
      const cartUrl = routes.cart_url ? `${routes.cart_url}.js` : '/cart.js';

      const sectionIds = [...document.querySelectorAll('cart-items-component')]
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);

      button.dataset.busy = 'true';
      button.classList.add('is-loading');

      try {
        const body = new FormData();
        body.append('id', variantId);
        body.append('quantity', '1');
        if (sectionIds.length) body.append('sections', sectionIds.join(','));

        const res = await fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body,
        });
        const data = await res.json();

        if (data.status) {
          console.warn('Bestsellers add to cart failed', data.message || data.description);
          return;
        }

        let cart = null;
        try {
          cart = await (await fetch(cartUrl)).json();
        } catch (err) {
          /* non-fatal */
        }

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'tos-coverflow',
              data: {
                source: 'product-form-component',
                itemCount: 1,
                productId: button.dataset.productId,
                sections: data.sections,
              },
            },
          })
        );

        button.dataset.added = 'true';
        setTimeout(() => button.removeAttribute('data-added'), 2000);

        // Make the add obvious: bounce the header cart icon
        document.querySelectorAll('.header-actions__cart-icon').forEach((icon) => {
          icon.classList.remove('tos-cart-bump');
          void icon.offsetWidth;
          icon.classList.add('tos-cart-bump');
        });
      } catch (err) {
        console.warn('Bestsellers add to cart error', err);
      } finally {
        button.classList.remove('is-loading');
        button.dataset.busy = 'false';
      }
    }

    #formatMoney(amount) {
      if (amount == null || amount === '') return '';
      const format = this.root.dataset.moneyFormat || '₹{{amount}}';
      const num = Number(amount);
      if (Number.isNaN(num)) return String(amount);
      const fixed = num.toFixed(2);
      const noDecimals = String(Math.round(num));
      const withComma = fixed.replace('.', ',');
      const withGroup = fixed.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      return format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, withGroup);
    }

    #escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    #shuffleArray(items) {
      const order = [...items];
      for (let i = order.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [order[i], order[j]] = [order[j], order[i]];
      }
      return order;
    }

    #shuffleInPlace(showCount) {
      const order = this.#shuffleArray(this.slides);
      const keep = order.slice(0, Math.min(showCount, order.length));
      order.slice(keep.length).forEach((slide) => slide.remove());
      keep.forEach((slide, i) => {
        slide.dataset.index = String(i);
        this.track?.appendChild(slide);
      });
      this.slides = keep;
      this.index = 0;
    }

    #bind() {
      this.root.querySelector('[data-tos-cf-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.root.querySelector('[data-tos-cf-next]')?.addEventListener('click', () => this.go(this.index + 1));

      this.viewport?.addEventListener('pointerdown', (e) => this.#onPointerDown(e));
      window.addEventListener('pointermove', (e) => this.#onPointerMove(e));
      window.addEventListener('pointerup', () => this.#onPointerUp());

      this.slides.forEach((slide, i) => {
        slide.addEventListener('click', (e) => {
          if (e.target.closest('[data-tos-cf-atc]')) return;
          if (Math.abs(this.dragX) > 8) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          if (i !== this.index) {
            e.preventDefault();
            e.stopPropagation();
            this.go(i);
          }
        });
      });

      this.track?.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-tos-cf-atc]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        this.#addToCart(btn);
      });

      window.addEventListener('keydown', (e) => {
        if (!this.root.matches(':hover')) return;
        if (e.key === 'ArrowLeft') this.go(this.index - 1);
        if (e.key === 'ArrowRight') this.go(this.index + 1);
      });
    }

    #buildDots() {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      this.slides.forEach((_, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tos-coverflow__dot';
        btn.addEventListener('click', () => this.go(i));
        this.dotsWrap.appendChild(btn);
      });
      this.dots = [...this.dotsWrap.querySelectorAll('.tos-coverflow__dot')];
    }

    go(next) {
      const total = this.slides.length;
      if (total === 0) return;
      this.index = ((next % total) + total) % total;
      this.#render();
    }

    #circularOffset(i) {
      const total = this.slides.length;
      let offset = i - this.index;
      const half = total / 2;
      if (offset > half) offset -= total;
      if (offset < -half) offset += total;
      return offset;
    }

    #render() {
      const styles = getComputedStyle(this.root);
      const spread = parseFloat(styles.getPropertyValue('--tos-cf-spread')) || 84;
      const scaleStep = parseFloat(styles.getPropertyValue('--tos-cf-scale-step')) || 0.06;
      const total = this.slides.length;
      const maxSide = Math.max(1, Math.floor((total - 1) / 2));
      const sideCount = Math.min(this.sideCount, maxSide);
      const styleName = this.root.dataset.stackStyle || 'stack';

      this.slides.forEach((slide, i) => {
        const offset = this.#circularOffset(i);
        const abs = Math.abs(offset);
        const visible = abs <= sideCount;
        const pose = this.#poseFor(styleName, offset, abs, spread, scaleStep);

        slide.style.transform = pose.transform;
        slide.style.opacity = visible ? pose.opacity : '0';
        slide.style.zIndex = String(20 - abs);
        slide.style.filter = pose.filter;
        slide.classList.toggle('is-active', abs === 0);
        slide.classList.toggle('is-far', !visible);
        slide.setAttribute('aria-hidden', abs === 0 ? 'false' : 'true');
        slide.style.pointerEvents = visible ? 'auto' : 'none';
      });

      this.dots?.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
    }

    #poseFor(styleName, offset, abs, spread, scaleStep) {
      const sign = offset === 0 ? 0 : Math.sign(offset);

      if (styleName === 'fan') {
        const scale = Math.max(0.82, 1 - abs * scaleStep);
        const x = offset * spread;
        const y = abs * abs * 2.8;
        const rot = offset * 2.4;
        return {
          transform: `translate(-50%, -50%) translateX(${x}px) translateY(${y}px) rotate(${rot}deg) scale(${scale})`,
          opacity: String(Math.max(0.62, 1 - abs * 0.07)),
          filter: abs === 0 ? 'none' : `brightness(${Math.max(0.92, 1 - abs * 0.02)})`,
        };
      }

      if (styleName === 'cascade') {
        const scale = Math.max(0.84, 1 - abs * scaleStep);
        const x = offset * spread;
        const y = abs * 8;
        return {
          transform: `translate(-50%, -50%) translateX(${x}px) translateY(${y}px) scale(${scale})`,
          opacity: String(Math.max(0.64, 1 - abs * 0.06)),
          filter: abs === 0 ? 'none' : `brightness(${Math.max(0.92, 1 - abs * 0.018)})`,
        };
      }

      if (styleName === 'ribbon') {
        const scale = Math.max(0.86, 1 - abs * scaleStep);
        const x = offset * spread;
        return {
          transform: `translate(-50%, -50%) translateX(${x}px) scale(${scale})`,
          opacity: String(Math.max(0.68, 1 - abs * 0.055)),
          filter: abs === 0 ? 'none' : `brightness(${Math.max(0.94, 1 - abs * 0.015)})`,
        };
      }

      const scale = Math.max(0.84, 1 - abs * scaleStep);
      const x = offset * spread + sign * Math.min(abs, 4) * 2;
      const y = abs * 4;
      return {
        transform: `translate(-50%, -50%) translateX(${x}px) translateY(${y}px) scale(${scale})`,
        opacity: String(Math.max(0.64, 1 - abs * 0.06)),
        filter: abs === 0 ? 'none' : `brightness(${Math.max(0.92, 1 - abs * 0.018)})`,
      };
    }

    #onPointerDown(e) {
      if (e.button != null && e.button !== 0) return;
      this.dragging = true;
      this.startX = e.clientX;
      this.dragX = 0;
      this.viewport?.classList.add('is-dragging');
    }

    #onPointerMove(e) {
      if (!this.dragging) return;
      this.dragX = e.clientX - this.startX;
    }

    #onPointerUp() {
      if (!this.dragging) return;
      this.dragging = false;
      this.viewport?.classList.remove('is-dragging');
      if (this.dragX > 50) this.go(this.index - 1);
      else if (this.dragX < -50) this.go(this.index + 1);
      this.dragX = 0;
    }
  }

  document.querySelectorAll('[data-tos-coverflow]').forEach((el) => new TosCoverflow(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-story-timeline"] && !Shopify.designMode) return;
  try {
    
  class TosStoryTimeline {
    constructor(root) {
      this.root = root;
      this.cycleMs = Number(root.dataset.cycle || 4000);
      this.chapters = [...root.querySelectorAll('[data-tos-chapter]')];
      this.timers = new Map();
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.#init();
    }

    #init() {
      this.chapters.forEach((chapter, chapterIndex) => {
        this.#setupStack(chapter, chapterIndex);
      });

      this.#bindResize();

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-inview');
                this.#playDrop(entry.target);
                this.#startCycle(entry.target);
              } else {
                this.#stopCycle(entry.target);
              }
            });
          },
          { threshold: 0.28, rootMargin: '0px 0px -8% 0px' }
        );
        this.chapters.forEach((chapter) => io.observe(chapter));
      } else {
        this.chapters.forEach((chapter) => {
          chapter.classList.add('is-inview');
          this.#playDrop(chapter);
          this.#startCycle(chapter);
        });
      }
    }

    #bindResize() {
      this.lastBand = this.#band();
      let raf = 0;

      window.addEventListener('resize', () => {
        window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(() => {
          const band = this.#band();
          if (band === this.lastBand) return;
          this.lastBand = band;

          this.chapters.forEach((chapter, chapterIndex) => {
            const front = chapter._tosFront || 0;
            this.#setupStack(chapter, chapterIndex);
            this.#applyFront(chapter, front, false);
            if (chapter.classList.contains('is-inview')) {
              (chapter._tosCards || []).forEach((card) => card.classList.add('is-ready'));
            }
          });
        });
      });
    }

    #band() {
      const w = window.innerWidth;
      if (w <= 749) return 'phone';
      if (w <= 989) return 'tablet';
      return 'desktop';
    }

    #setupStack(chapter, chapterIndex) {
      const cards = [...chapter.querySelectorAll('[data-tos-card]')];
      const width = window.innerWidth;
      const isPhone = width <= 749;
      const isTablet = width > 749 && width <= 989;

      let tilts = [-11, -5, 3, 8, -2, 6, -8];
      let shifts = [
        [-18, 10],
        [14, -8],
        [-8, 16],
        [20, 6],
        [-14, -12],
      ];

      if (isTablet) {
        tilts = [-8, -3, 3, 6, -4];
        shifts = [
          [-11, 7],
          [9, -5],
          [-5, 10],
          [12, 4],
          [-8, -7],
        ];
      }

      if (isPhone) {
        tilts = [-6, -2, 2, 5, -3];
        shifts = [
          [-7, 5],
          [6, -4],
          [-4, 7],
          [8, 3],
          [-5, -4],
        ];
      }

      cards.forEach((card, i) => {
        const tilt = tilts[(i + chapterIndex) % tilts.length];
        const [sx, sy] = shifts[i % shifts.length];
        card.dataset.baseTilt = String(tilt);
        card.dataset.baseX = String(sx);
        card.dataset.baseY = String(sy);
        card.style.setProperty('--tos-tilt', `${tilt}deg`);
        card.style.setProperty('--tos-shift-x', `${sx}px`);
        card.style.setProperty('--tos-shift-y', `${sy}px`);
        card.style.zIndex = String(cards.length - i);
      });

      chapter._tosCards = cards;
      chapter._tosFront = 0;
      this.#applyFront(chapter, 0, false);
    }

    #playDrop(chapter) {
      const cards = chapter._tosCards || [];
      cards.forEach((card, i) => {
        card.classList.remove('is-ready');
        card.style.setProperty('--tos-drop-y', '64px');
        const delay = this.reduceMotion ? 0 : 90 + i * 110;
        window.setTimeout(() => {
          card.classList.add('is-ready');
        }, delay);
      });
    }

    #applyFront(chapter, frontIndex, animate) {
      const cards = chapter._tosCards || [];
      if (!cards.length) return;
      const total = cards.length;
      const front = ((frontIndex % total) + total) % total;
      chapter._tosFront = front;

      cards.forEach((card, i) => {
        const dist = (i - front + total) % total;
        const isFront = i === front;
        const baseTilt = Number(card.dataset.baseTilt || 0);
        const baseX = Number(card.dataset.baseX || 0);
        const baseY = Number(card.dataset.baseY || 0);
        const depth = isFront ? 0 : Math.min(dist, 4);
        const width = window.innerWidth;
        const isPhone = width <= 749;
        const isTablet = width > 749 && width <= 989;
        const depthY = isPhone ? 5 : isTablet ? 8 : 12;
        const depthTilt = isPhone ? 0.6 : isTablet ? 1 : 1.4;
        const depthX = isPhone ? 1 : isTablet ? 1.5 : 2;

        card.classList.toggle('is-front', isFront);
        card.style.zIndex = isFront ? '20' : String(total - dist);
        card.style.setProperty('--tos-tilt', `${baseTilt + depth * depthTilt}deg`);
        card.style.setProperty('--tos-shift-x', `${baseX + (isFront ? 0 : depth * depthX)}px`);
        card.style.setProperty('--tos-shift-y', `${baseY + depth * depthY}px`);

        if (isFront && animate && !this.reduceMotion) {
          card.classList.remove('is-ready');
          card.style.setProperty('--tos-drop-y', '-42px');
          void card.offsetWidth;
          requestAnimationFrame(() => {
            card.classList.add('is-ready');
            window.setTimeout(() => {
              card.style.setProperty('--tos-drop-y', '64px');
            }, 850);
          });
        }
      });
    }

    #startCycle(chapter) {
      this.#stopCycle(chapter);
      const cards = chapter._tosCards || [];
      if (cards.length < 2 || this.reduceMotion) return;

      const id = window.setInterval(() => {
        const next = (chapter._tosFront + 1) % cards.length;
        this.#applyFront(chapter, next, true);
      }, Math.max(2200, this.cycleMs));

      this.timers.set(chapter, id);
    }

    #stopCycle(chapter) {
      const id = this.timers.get(chapter);
      if (id) {
        window.clearInterval(id);
        this.timers.delete(chapter);
      }
    }
  }

  document.querySelectorAll('[data-tos-story]').forEach((el) => new TosStoryTimeline(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tos-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tos-banner-carousel')) {
    class TosHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.tos-banner__slide')];
        this.dots = [...this.querySelectorAll('.tos-banner__dot')];
        this.pauseButton = this.querySelector('[data-pause]');
        if (this.slides.length < 2) return;

        this.index = 0;
        this.interval = Number(this.dataset.interval) || 5000;
        this.style.setProperty('--tos-banner-interval', `${this.interval}ms`);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.userPaused = this.dataset.autoplay !== 'true' || this.reducedMotion;
        this.hoverPaused = false;
        if (this.pauseButton) this.#syncPauseButton();

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.go))));
        this.pauseButton?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.#syncPauseButton();
          this.#schedule();
        });

        this.addEventListener('mouseenter', () => this.#setHover(true));
        this.addEventListener('mouseleave', () => this.#setHover(false));
        this.addEventListener('focusin', () => this.#setHover(true));
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.#setHover(false);
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.go(this.index - 1);
          if (event.key === 'ArrowRight') this.go(this.index + 1);
        });

        this.#bindSwipe();
        this.onVisibility = () => this.#schedule();
        document.addEventListener('visibilitychange', this.onVisibility);

        // Theme editor: jump to the slide being edited
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('.tos-banner__slide');
          if (slide) {
            this.userPaused = true;
            this.#syncPauseButton();
            this.go(Number(slide.dataset.index));
          }
        });

        this.#schedule();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      go(next) {
        const count = this.slides.length;
        const target = (next + count) % count;
        if (target === this.index) {
          this.#schedule();
          return;
        }

        this.slides.forEach((slide, i) => {
          const active = i === target;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });

        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === target);
          dot.classList.toggle('is-done', i < target);
          if (i === target) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
          // restart the progress animation
          const fill = dot.firstElementChild;
          if (fill && i === target) {
            fill.style.animation = 'none';
            void fill.offsetWidth;
            fill.style.animation = '';
          }
        });

        this.index = target;
        this.#schedule();
      }

      #schedule() {
        clearTimeout(this.timer);
        const paused = this.userPaused || this.hoverPaused || document.hidden;
        this.classList.toggle('is-paused', paused);
        if (paused) return;
        this.timer = setTimeout(() => this.go(this.index + 1), this.interval);
      }

      #setHover(state) {
        this.hoverPaused = state;
        if (state) {
          clearTimeout(this.timer);
          this.classList.add('is-paused');
        } else {
          // restart the progress bar so it matches the fresh timer
          this.dots[this.index]?.firstElementChild?.style.setProperty('animation', 'none');
          void this.offsetWidth;
          this.dots[this.index]?.firstElementChild?.style.removeProperty('animation');
          this.#schedule();
        }
      }

      #syncPauseButton() {
        if (!this.pauseButton) return;
        this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
        this.pauseButton.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
        this.dataset.autoplay = String(!this.userPaused);
      }

      #bindSwipe() {
        let startX = null;
        let startY = null;
        const track = this.querySelector('.tos-banner__slides');
        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          startX = event.clientX;
          startY = event.clientY;
        });
        track.addEventListener('pointerup', (event) => {
          if (startX === null) return;
          const dx = event.clientX - startX;
          const dy = event.clientY - startY;
          startX = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1));
        });
        track.addEventListener('pointercancel', () => (startX = null));
      }
    }

    customElements.define('tos-banner-carousel', TosHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
